export function safeGetLocalStorage() {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function getFromStorage(key: string): string | null {
  const ls = safeGetLocalStorage();
  if (!ls) return null;
  try {
    return ls.getItem(key);
  } catch {
    return null;
  }
}

export function setInStorage(key: string, value: string) {
  const ls = safeGetLocalStorage();
  if (!ls) return;
  try {
    ls.setItem(key, value);
  } catch {
    return null;
  }
}

export function removeFromStorage(key: string) {
  const ls = safeGetLocalStorage();
  if (!ls) return;
  try {
    ls.removeItem(key);
  } catch {
    return null;
  }
}
